module.exports = __webpack_public_path__ + "static/media/lohana_mahaparishad.2b9cc69b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lohana_mahaparishad.png
// module id = 984
// module chunks = 0